const AdvantagesSection = () => {
  return (
    <section id="vantagens" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="border-l-4 border-blue-500 pl-6">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                Por que a Desentupidora da Cidade Nº1 é a #1 em Campinas e Região?
              </h2>
            </div>

            <h3 className="text-2xl font-semibold text-green-600">
              🏆 Mais de 10.000 clientes satisfeitos confiam na nossa expertise!
            </h3>

            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                <strong>Desentupidora da Cidade Nº1 em Campinas e Região</strong> é líder absoluta em desentupimento 24
                horas! Nossa equipe de <strong>técnicos certificados</strong> resolve 98% dos
                entupimentos em apenas uma visita, utilizando <strong>hidrojateamento profissional</strong>{' '}
                e equipamentos de última geração importados.
              </p>

              <p>
                ⚡ <strong>EXCLUSIVO:</strong> Somos a única desentupidora em Campinas e Região com
                <strong>tecnologia de vídeo-inspeção</strong> que identifica o problema antes mesmo de
                começar o serviço. Isso garante <strong>solução definitiva</strong> sem quebrar pisos,
                azulejos ou paredes!
              </p>

              <p>
                🚨 <strong>ATENÇÃO:</strong> Entupimento não resolvido pode causar refluxo de esgoto,
                mau cheiro permanente e até infiltrações. Nossa equipe <strong>chega em 30 minutos</strong>{' '}
                para evitar que seu problema se torne um pesadelo!{' '}
                <strong>Desentupimento de emergência</strong> todos os dias, inclusive domingos e
                feriados.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">
                  💰 <strong>Orçamento 100% GRATUITO</strong> - Vamos até sua casa sem cobrar nada
                  pela visita
                </span>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">
                  💳 <strong>Facilidade Total:</strong> Pague no PIX com desconto ou parcele em até
                  10x sem juros
                </span>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">
                  🛡️ <strong>Garantia BLINDADA:</strong> 3 meses de garantia total - Se entupir de
                  novo, voltamos GRÁTIS
                </span>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">
                  📋 <strong>Contratos VIP:</strong> Manutenção preventiva mensal - Nunca mais tenha
                  entupimentos
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">Serviço com Garantia</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Seguimos todas as normas técnicas.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-white text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">Mão de obra especializada</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Temos equipamentos modernos e técnicos especializados.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-card-line text-white text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">Pagamento Facilitado</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Você pode pagar com PIX ou parcelar em até 3 vezes nos cartões.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-white text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">Orçamento e visita grátis</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Nosso orçamento é grátis, inclusive se precisar fazer visita.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;